import { multiselect } from '@/lang/ro/common/multiselect'
import { calendar } from '@/lang/ro/common/calendar'
import { texts } from '@/lang/ro/common/texts'
import { numericInput } from '@/lang/ro/common/numeric-input'
import { datepicker } from '@/lang/ro/common/datepicker'
import { lookupsActions } from '@/lang/ro/common/lookups-actions'
import { attachments } from '@/lang/ro/common/attachments'
import { auditLog } from '@/lang/ro/common/auditLog'
import { notificationSubscription } from '@/lang/ro/common/notification-subscription'
import { linkButton } from '@/lang/ro/common/link-button'
import { entities } from '@/lang/ro/common/entities'
import { userPreferences } from '@/lang/ro/common/user-preferences'
import { agenda } from '@/lang/ro/common/agenda'

export const common = {
  texts,
  multiselect,
  calendar,
  lookupsActions,
  numericInput,
  attachments,
  auditLog,
  datepicker,
  notificationSubscription,
  linkButton,
  entities,
  userPreferences,
  agenda
}
